module.exports = __webpack_public_path__ + "img/about3.6a665080.png";